import React from "react";

const Safeharbor = () => {
  return (
    <div className="work__withus section__margin" id="work-with-us">
      <div className="work__withus-header">
      <h1 className="gradient__text_2">Safe Harbor Statement</h1>
      <p>
        Some of the statements on this site that are neither reported financial results nor historical facts are forward-looking statements. These forward-looking statements include our financial and growth projections as well as statements concerning our plans, strategies, intentions, and beliefs concerning our business and the markets in which we operate.
      </p>
      <p>
        These statements are based on information currently available to us, and we assume no obligation to update these statements as circumstances change. There are risks and uncertainties that could cause actual events to differ materially from these forward-looking statements. 
      </p>
      <p>
        These risks include, but are not limited to, the level of market demand for our services, the highly competitive market for the types of services that we offer, market conditions that could cause our customers to reduce their spending for our services, our ability to create, acquire, and build new businesses and to grow our existing businesses, our ability to attract and retain qualified personnel, currency fluctuations and market conditions in India and elsewhere around the world, and other risks not specifically mentioned herein but those that are common to the industry.
      </p>
    </div>
    </div>
  );
};

export default Safeharbor;
